import * as React from 'react'
import cn from 'classnames'

export type ProficiencyDotsProps = {
  level: number | null
  totalDots?: number
  className?: string
  filledColor?: 'green' | 'orange' | 'theme'
}

export const ProficiencyDots: React.FC<ProficiencyDotsProps> = ({
  level,
  totalDots = 5,
  className,
  filledColor = 'green',
}) => {
  if (level === null || level === undefined) {
    return <span className="text-gray-400">-</span>
  }

  const filledDots = Math.round(level)

  const filledColorClass =
    filledColor === 'orange'
      ? 'bg-orange-600'
      : filledColor === 'theme'
      ? 'bg-theme-50'
      : 'bg-green-600'

  return (
    <div className={cn('flex gap-[5px]', className)}>
      {Array.from({ length: totalDots }).map((_, index) => (
        <div
          key={index}
          className={cn('w-[10px] h-[10px] rounded-full', {
            [filledColorClass]: index < filledDots,
            'bg-gray-200': index >= filledDots,
          })}
        />
      ))}
    </div>
  )
}
